import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";
import WhatsAppFloatingButton from "./components/WhatsAppFloatingButton";

// Pages
import Home from "./pages/Home";
import Catalogo from "./pages/Catalogo";
import ProductoDetalle from "./pages/ProductoDetalle";
import Carrito from "./pages/Carrito";
import MiCuenta from "./pages/MiCuenta";
import Checkout from "./pages/Checkout";
import Ofertas from "./pages/Ofertas";
import Nosotros from "./pages/Nosotros";
import Terminos from "./pages/Terminos";
import Admin from "./pages/Admin";
import AdminSecurity from "./pages/AdminSecurity";
import PagoResultado from "./pages/PagoResultado";
import NewsletterRegistroExitoso from "./pages/NewsletterRegistroExitoso";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
};

function App() {
  const [carritoCount, setCarritoCount] = useState(0);

  useEffect(() => {
    // Actualizar contador del carrito
    const actualizarCarrito = () => {
      const carrito = JSON.parse(localStorage.getItem('carrito') || '[]');
      const count = carrito.reduce((total, item) => total + item.cantidad, 0);
      setCarritoCount(count);
    };

    actualizarCarrito();

    // Escuchar cambios en localStorage
    window.addEventListener('storage', actualizarCarrito);
    
    // Polling para actualizar el contador (cuando se agrega desde la misma pestaña)
    const interval = setInterval(actualizarCarrito, 1000);

    return () => {
      window.removeEventListener('storage', actualizarCarrito);
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header carritoCount={carritoCount} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/catalogo/:categoria" element={<Catalogo />} />
          <Route path="/producto/:id" element={<ProductoDetalle />} />
          <Route path="/carrito" element={<Carrito />} />
          <Route path="/mi-cuenta" element={<MiCuenta />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/ofertas" element={<Ofertas />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/terminos" element={<Terminos />} />
          <Route path="/privacidad" element={<Terminos />} />
          <Route path="/pago/resultado" element={<PagoResultado />} />
          <Route
            path="/newsletter/registro-exitoso"
            element={<NewsletterRegistroExitoso />}
          />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin-seguridad" element={<AdminSecurity />} />
        </Routes>
        <WhatsAppFloatingButton />
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
